import { compose, withHandlers } from 'recompose';
import { logData } from '../../Common/Providers/LogApi';

export const withDataLayerPush = compose(
  withHandlers({
    dataLayerPush: () => ({ event = 'dataLayerLoaded', ...payload }) => {
      window.dataLayer.push({
        event,
        ...payload
      });

      if (['purchase', 'order'].includes(event))
        logData({ event, ...payload });
    }
  })
);



// WEBPACK FOOTER //
// ./src/Common/GTM/withDataLayerPush.js